// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"b62c21a1","378":"ae8438b9","394":"2881c34b"}[chunkId] + ".chunk.css";
};